// default variables
const url = "http://192.168.0.243:4000/";
//const urlYiipro = 'http://dalbum.yiipro.com/api/';
const urlYiipro = process.env.REACT_APP_MIDDLEWARE_BASE_URL;
const urlLocalhost = process.env.REACT_APP_MIDDLEWARE_BASE_URL;

export default urlYiipro;
